module.exports = __webpack_public_path__ + "static/bg.586b2f5d.png";